/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { OrderDetailsDto as DigiworkMaitreDPosDtoOrderV2OrderDetailsDto } from '../../models/Digiwork/MaitreD/Pos/DTO/OrderV2/order-details-dto';

export interface GetOrder$Params {
  orderId: string;
}

export function getOrder(http: HttpClient, rootUrl: string, params: GetOrder$Params, context?: HttpContext): Observable<StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrderDetailsDto>> {
  const rb = new RequestBuilder(rootUrl, getOrder.PATH, 'get');
  if (params) {
    rb.path('orderId', params.orderId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<DigiworkMaitreDPosDtoOrderV2OrderDetailsDto>;
    })
  );
}

getOrder.PATH = '/api/orders/{orderId}/details';
